import { useEffect, useState } from 'react';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export const ALL_INVOICES_LIMIT = 500;

// Alle direktefakturaer (kind: 'driver-to-orderer' | 'credit-note') for admin, nyeste først.
// Gamle per-ordre-fakturaer ligger i samme samling, så grensen settes før kind-filteret.
export function useAllDirectInvoices() {
  const [invoices, setInvoices]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    const q = query(collection(db, 'invoices'), orderBy('createdAt', 'desc'), limit(ALL_INVOICES_LIMIT));
    return onSnapshot(q, snap => {
      setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(i => i.kind));
      setTruncated(snap.docs.length >= ALL_INVOICES_LIMIT);
      setError(null);
      setLoading(false);
    }, err => {
      console.error('useAllDirectInvoices:', err);
      setInvoices([]);
      setTruncated(false);
      setError(err);
      setLoading(false);
    });
  }, []);

  return { invoices, loading, error, truncated };
}
